import { Operator } from '@/common/model/operator'

export const OperatorApiPath = {
  LIST_OPERATORS: '/api/operators', // GET List Operators
  CREATE_OPERATOR: '/api/operators', // POST Create Operator
  UPDATE_OPERATOR: '/api/operators/{operator_id}', // PUT Update Operator
  DELETE_OPERATOR: '/api/operators/{operator_id}', // DELETE Delete Operator
  LIST_ALL_ACCOUNTS: '/api/operators/all-accounts' // GET List All Accounts
}

export type OperatorApiPath = (typeof OperatorApiPath)[keyof typeof OperatorApiPath]

export interface ListOperatorsVars {}

export interface CreateOperatorVars {
  // W2 オペレーター（全体管理者）。ログインIDは email。
  email: string
  password: string
  name: string
}

export interface UpdateOperatorVars {
  operator_id: number
  email?: string | null
  password?: string | null
  name?: string | null
}

export interface DeleteOperatorVars {
  operator_id: number
}

export interface ListAllAccountsVars {
  site_name?: string | null
}

export type ListOperatorsResponse = Operator[]
export type CreateOperatorResponse = Operator
export type UpdateOperatorResponse = Operator

export interface DeleteOperatorResponse {
  deleted: boolean
}

export type ListAllAccountsResponse = {
  id: number
  site_id: number
  login_id: string
  email: string | null
  created_at: string
}[]
